var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import GlobalVue from "../../globalVue";
import PurInService from "../../api/PurInService";
import CommonService from '../../api/CommonService';
import { toDetail } from "../../helper/util";
import { EBillType } from "../../enum/EBillType";
import { EPurInStatus } from "../../enum/EStatus";
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import MulShopOamount from "./MulShopOamount.vue";
import GoodTable from "./GoodTable.vue";
import ELogisticsType from "../../enum/ELogisticsType";
import ImageView from "./components/ImageViewer.vue";
var PurInDetail = (function (_super) {
    __extends(PurInDetail, _super);
    function PurInDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {};
        _this.goodData = [];
        _this.shopGoodData = [];
        _this.ePurInStatus = EPurInStatus;
        _this.eLogisticsType = ELogisticsType;
        _this.defaultType = 'byGood';
        _this.imageOpen = false;
        _this.imageArr = [];
        _this.supplierGoodsTypeList = [];
        _this.goodsFormData = {
            goods_type_id: undefined,
            keyword: '',
        };
        return _this;
    }
    PurInDetail.prototype.created = function () {
        this.service = PurInService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    PurInDetail.prototype.mounted = function () {
        this.getDetail();
        this.getGoodsTypeList();
    };
    PurInDetail.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    PurInDetail.prototype.search = function () {
        this.getDetail();
    };
    PurInDetail.prototype.getGoodsTypeList = function () {
        var _this = this;
        this.commonService.getSupplierGoodsTypeList().then(function (res) {
            if (res.data.success) {
                _this.supplierGoodsTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PurInDetail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.rowId,
            goods_type_id: this.goodsFormData.goods_type_id,
            keyword: this.goodsFormData.keyword,
        };
        this.service.getDetail(params).then(function (res) {
            _this.formData = res.data.data;
            _this.goodData = _this.formData.items;
            _this.goodData.forEach(function (item, index) {
                if (item.order_goods_replace && item.order_goods_replace.length !== 0) {
                    item.children = [item.order_goods_replace];
                }
                item.isIndex = true;
                item.parentIndex = index + 1;
            });
            _this.shopGoodData = _this.formData.shop_items;
            _this.shopGoodData.map(function (shop) {
                shop.items.map(function (item, index) {
                    if (item.order_goods_replace && item.order_goods_replace.length !== 0) {
                        item.children = [item.order_goods_replace];
                    }
                    item.isIndex = true;
                    item.parentIndex = index + 1;
                });
            });
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurInDetail.prototype.toPurOrderDetail = function () {
        toDetail(EBillType.PurOrder, this.formData.purchase_order_order_id);
    };
    PurInDetail.prototype.toDeliverDetail = function () {
        if (this.formData.logistics_type == 4 || this.formData.logistics_type == 5) {
            toDetail(EBillType.EntrustedDeliver, this.formData.delivery_order_id);
        }
        else {
            toDetail(EBillType.Deliver, this.formData.delivery_order_id);
        }
    };
    PurInDetail.prototype.mulConfirm = function () {
        var _this = this;
        this.$confirm("是否要确认", "提示", {}).then(function (res) {
            var params = {
                order_id: _this.formData.order_id
            };
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.confirm(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getDetail();
                }
                else {
                    _this.$message.success(res.data.msg || "修改成功");
                    GlobalVue.$emit("closeTab", _this);
                    if (_this.opener && _this.opener.getList) {
                        _this.opener.getList();
                    }
                }
                window._czc.push(["_trackEvent", '客户入库确认', '客户入库确认']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        }, function () {
        });
    };
    PurInDetail.prototype.closeimg = function (type) {
        this.imageOpen = type;
    };
    PurInDetail.prototype.watchImg = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.orderImgById({ order_id: this.rowId }).then(function (res) {
            console.log(res.data);
            _this.imageArr = Array.isArray(res.data.data) ? res.data.data : [];
            loadingInstance.close();
            _this.imageOpen = true;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurInDetail = __decorate([
        auth(nameDict["入库单"]),
        Component({
            components: {
                "mul-shop-oamount": MulShopOamount,
                GoodTable: GoodTable,
                'image-view': ImageView
            },
        })
    ], PurInDetail);
    return PurInDetail;
}(Vue));
export default PurInDetail;
